import { Pages, Paths } from '../navigation';
import React, { createContext, ReactNode, useContext, useState } from 'react';

export type TicketSearchOrigin = Extract<Paths, 'scan-bet' | 'manual-entry'>;
export const PageToTicketSearchOrigin: Record<Extract<Pages, 'TicketEntry' | 'Scan'>, TicketSearchOrigin> = {
  TicketEntry: 'manual-entry',
  Scan: 'scan-bet'
};

export interface TicketSearchContextAttributes {
  ticketNumber: string;
  error?: string;
  origin: TicketSearchOrigin;
}

export interface TicketSearchContextProps {
  context: TicketSearchContextAttributes | undefined;
  setContext: (context: TicketSearchContextAttributes) => void;
  clearContext: () => void;
}

export const TicketSearchContext = createContext<TicketSearchContextProps>({
  context: undefined,
  setContext: () => {},
  clearContext: () => {}
});

export function TicketSearchContextProvider({ children }: { children: ReactNode }) {
  const [currentContext, setCurrentContext] = useState<TicketSearchContextAttributes | undefined>();
  const value = {
    context: currentContext,
    setContext,
    clearContext
  };

  return <TicketSearchContext.Provider value={value}>{children}</TicketSearchContext.Provider>;

  function setContext(newContext: TicketSearchContextAttributes) {
    setCurrentContext({ ...newContext });
  }
  function clearContext() {
    setCurrentContext(undefined);
  }
}

export default function useTicketSearchContext() {
  const context = useContext(TicketSearchContext);
  return {
    ...context
  };
}
